type TCloseHandler = () => void;

interface IGroupState {
  instances: Map<string, TCloseHandler>;
}

const groups = new Map<string, IGroupState>();

export const registerTipInGroup = (
  groupId: string,
  instanceId: string,
  close: TCloseHandler,
): (() => void) => {
  if (!groups.has(groupId)) {
    groups.set(groupId, { instances: new Map() });
  }
  groups.get(groupId)!.instances.set(instanceId, close);
  return () => {
    groups.get(groupId)?.instances.delete(instanceId);
  };
};

/** 打开当前 tip 前，先关闭同组其它 tip */
export const activateTipInGroup = (groupId: string, instanceId: string): void => {
  const group = groups.get(groupId);
  if (!group) {
    return;
  }
  group.instances.forEach((close, id) => {
    if (id !== instanceId) {
      close();
    }
  });
};

/** 关闭同组全部 tip（用于父容器 mouseleave） */
export const closeTipGroup = (groupId: string): void => {
  const group = groups.get(groupId);
  if (!group) {
    return;
  }
  group.instances.forEach(close => close());
};
